import { ProductIdentifier } from 'components/common/types/DirectSalesProductTemplate.types';

export const getProductsToDisplayByStatus = ({
  isShowDisabled,
  products,
}: {
  isShowDisabled: boolean;
  products: ProductIdentifier[];
}): ProductIdentifier[] => {
  return isShowDisabled ? products : products.filter(({ status }) => status === 'ACTIVE');
};
